.file-input {
    display: flex;
    align-items: center;

    & > label:has(> input:focus) {
        outline-offset: 1px;
        outline: 1px solid var(--cs-light);
    }

    & > label > input {
        /*display: none;*/
        opacity: 0;
        position: absolute;
    }
}